<mat-card>
    <mat-card-header>
      <mat-card-title>Búsqueda de {{'Pedido' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
  
      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>
  
      <ng-container *ngIf="canView">
  
        <mat-expansion-panel *ngIf="!isValidating">
  
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
  
          <form [formGroup]="searchForm">
            <div fxLayout="row stretch" fxLayout.xs="column">
              
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Número</mat-label>
                  <input matInput type="number" formControlName="PedidoId" placeholder="Número"
                    aria-label="Número" (keyup.enter)="onSearch()">
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{'Comunidad' | translate}} Origen</mat-label>
                  <input type="text" matInput [matAutocomplete]="obras"
                    formControlName="ComunidadOrigen" (keyup.enter)="onSearch()">
                  <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                    style="position: absolute; right: 0"></i>
                </mat-form-field>
                <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                  <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                    {{ sharedFunctions.formatComunidadName(s) }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div fxFlex=34 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{'Comunidad' | translate}} Destino</mat-label>
                  <input type="text" matInput
                    [matAutocomplete]="obras" formControlName="ComunidadDestino" (keyup.enter)="onSearch()">
                  <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                    style="position: absolute; right: 0"></i>
                </mat-form-field>
                <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                  <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                    {{ sharedFunctions.formatComunidadName(s) }}
                  </mat-option>
                </mat-autocomplete>
              </div>
  
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}</mat-label>
                  <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoMaterialId">
                    <mat-option [value]="0">Todos</mat-option>
                    <mat-option *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Ver pedidos facturados</mat-label>
                  <mat-select formControlName="FiltroFacturado">
                    <mat-option *ngFor="let s of filtroFacturadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
          </form>
          
        </mat-expansion-panel>
  
        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
          <button mat-raised-button (click)="add()" *ngIf="canEdit" [disabled]="isSearching" color="primary"
            class="zb-button">Agregar</button>
          <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary"
            class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
          <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="primary"
            class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
        </div>
  
        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
          <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
        </div>
  
        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
            [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
            [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
            <e-columns>
              <e-column field='Id' headerText='#' textAlign="center" width=50></e-column>
              <e-column field='ComunidadOrigenNombre' headerText='Origen' width=90></e-column>
              <e-column field='ComunidadDestinoNombre' headerText='Destino' width=90></e-column>
              <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
              <e-column field='TipoMaterialNombre' headerText='Tipo de Material' width=90></e-column>
              <e-column field='Observacion' headerText='Observación' width=90></e-column>
              <e-column headerText='Acciones' textAlign="center" width=90>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
  
      </ng-container>
  
    </mat-card-content>
  </mat-card>